module.exports = __webpack_public_path__ + "static/media/amazon.f700b4d1.395695e5.png";